import pro1 from '../assets/pro1.jpg'

function Slider() {

  return (
    <div className='slider'>
      <div className="slider-item">
        {/* <img style={{width: '100%'}} src={pro1} alt=""/> */}
      </div>
    </div>
  )
}

export default Slider